module.exports = __webpack_public_path__ + "media/images/stripe/blue-on-dark@2x-658fc3fda4f54ab288f6a4425ad3b9c4.png";